import { lazy, Suspense, type ReactElement } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/router/ProtectedRoute';
import { RoleRoute } from '@/router/RoleRoute';
import { RouteFallback } from '@/components/shared/RouteFallback';

// BUG-001 (BUGS.md) — route-based code splitting: har bir sahifa alohida chunk.
const StoresPage = lazy(() => import('./pages/StoresPage').then((m) => ({ default: m.StoresPage })));
const NewStorePage = lazy(() => import('./pages/NewStorePage').then((m) => ({ default: m.NewStorePage })));
const EditStorePage = lazy(() => import('./pages/EditStorePage').then((m) => ({ default: m.EditStorePage })));
const StatsPage = lazy(() => import('./pages/StatsPage').then((m) => ({ default: m.StatsPage })));
const NotificationsPage = lazy(() =>
  import('./pages/NotificationsPage').then((m) => ({ default: m.NotificationsPage })),
);
const ProfilePage = lazy(() => import('./pages/ProfilePage').then((m) => ({ default: m.ProfilePage })));

function agent(element: ReactElement): ReactElement {
  return (
    <ProtectedRoute>
      <RoleRoute roles={['AGENT', 'ADMIN']}>
        <Suspense fallback={<RouteFallback />}>{element}</Suspense>
      </RoleRoute>
    </ProtectedRoute>
  );
}

/**
 * F4 — Agent ekranlari (A-01…A-03).
 * CLAUDE.md §6 — registry.ts tomonidan avtomatik yig'iladi.
 * Yo'llar `lib/navConfig.ts` dagi NAV_CONFIG.AGENT bilan mos.
 */
export const routes: RouteObject[] = [
  { path: '/agent', element: agent(<StoresPage />) },
  { path: '/agent/stores/new', element: agent(<NewStorePage />) },
  { path: '/agent/stores/:id/edit', element: agent(<EditStorePage />) },
  { path: '/agent/stats', element: agent(<StatsPage />) },
  { path: '/agent/notifications', element: agent(<NotificationsPage />) },
  { path: '/agent/profile', element: agent(<ProfilePage />) },
];
